import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useFormikContext } from 'formik';
import { focusFirstError } from '../../../utils';
import { useWizardState, useWizardDispatch } from '../WizardContext';
import { GO_STEP } from '../constants';

const GoToStep = ({
  children,
  currentStep,
  dispatch,
  setTouched,
  totalSteps,
  validateForm,
  validationsSchema,
  values,
  hasSubmitted,
}) => {
  const handleOnClick = async (step) => {
    const FIRST_STEP = 0;
    const validationSteps = [];
    if (step !== currentStep) {
      for (let iter = step; iter >= 0; --iter) {
        try {
          // eslint-disable-next-line no-await-in-loop
          await validationsSchema[iter]().validate(values);
        } catch (err) {
          validationSteps.push({ ...err, step: iter });
        }
      }
      if (validationSteps.length) {
        const gostep = Math.min(...validationSteps.map((o) => o.step));
        dispatch({ type: GO_STEP, step: gostep });
        focusFirstError(document.forms[0], (currentField) => _.has(validationSteps[gostep].errors, currentField.name));
        return;
      }
    }

    if (step > totalSteps) {
      return;
    }
    const classIsActive = step === currentStep ? 'is-active' : '';
    const isVisited = step <= totalSteps && !classIsActive ? 'is-visited' : '';
    // validate on next
    validateForm().then((errors) => {
      if (_.isEmpty(errors)) {
        if (isVisited === '' && !hasSubmitted) {
          return;
        }

        setTouched({});
        dispatch({ type: GO_STEP, step, lastVisitedStep: (currentStep === totalSteps) ? totalSteps : FIRST_STEP });
      } else {
        setTouched(errors);
        if (currentStep > step) {
          dispatch({ type: GO_STEP, step });
        }
        focusFirstError(document.forms[0], (currentField) => _.has(errors, currentField.name));
      }
    });
  };
  return children ? children(handleOnClick) : null;
};

GoToStep.propTypes = {
  children: PropTypes.func,
  currentStep: PropTypes.number,
  dispatch: PropTypes.func,
  setTouched: PropTypes.func,
  totalSteps: PropTypes.number,
  validateForm: PropTypes.func,
  validationsSchema: PropTypes.arrayOf,
  values: PropTypes.objectOf,
  hasSubmitted: PropTypes.bool,
};

GoToStep.defaultProps = {
  children: (() => {}),
  currentStep: 0,
  dispatch: (() => {}),
  setTouched: (() => {}),
  totalSteps: 0,
  validateForm: (() => {}),
  validationsSchema: [],
  values: undefined,
  hasSubmitted: false,
};

const GoToStepContext = (props) => {
  const {
    totalSteps, currentStep, lastVisitedStep, validationsSchema, hasSubmitted,
  } = useWizardState();
  const dispatch = useWizardDispatch();
  const {
    setTouched, validateForm, submitForm, values,
  } = useFormikContext();

  return (
    <GoToStep
      {...props}
      {...{
        currentStep,
        dispatch,
        lastVisitedStep,
        setTouched,
        submitForm,
        totalSteps,
        validateForm,
        validationsSchema,
        values,
        hasSubmitted,
      }}
    />
  );
};

export default GoToStepContext;
